import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ProgressBarService } from '../../service/progress-bar.service';
import { Subscription } from 'rxjs';
import { ProgressState } from '../../model/progress-state';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressBarComponent implements OnDestroy, OnInit {
  constructor(private _service: ProgressBarService) {
    this._subscription = _service.stateChange.subscribe(state => {
      this.active = state === ProgressState.Active;
    });
  }

  private _subscription: Subscription;
  active: boolean;

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
  }

  ngOnInit() {}
}
